import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../../components/BreadCrumbs/BreadCrumbs';
import Page from '../../../../components/Page/Page';
import { SETTINGS } from '../../../../routes/routeConstants';
import AboutTheApi from './AboutTheApi';
import ApiKeyGenerationForm from './ApiKeyGenerationForm';
import ThirdPartyAPI from './ThirdPartyAPI';

const APIKeys = () => {
  const { pathname } = useLocation();
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Settings`,
        link: `/${SETTINGS}`,
      },
      {
        name: `API Keys`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | API Keys'>
      <Container>
        <BreadCrumbs pathData={pathArr as any} hideOnWeb />
        <ApiKeyGenerationForm />
        <ThirdPartyAPI />
        <AboutTheApi />
      </Container>
    </Page>
  );
};

export default APIKeys;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
